import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { DropdownComponent } from '@valk-nx/components/ui-dropdown/src/lib/dropdown';
import { LinkComponent } from '@valk-nx/components/ui-link/src/lib/link';

import { HeaderDesktopComponent } from './header-desktop';

@NgModule({
	declarations: [HeaderDesktopComponent],
	exports: [HeaderDesktopComponent],
	imports: [
		CommonModule,
		LinkComponent,
		DropdownComponent,
		RouterModule,
		TranslateModule.forChild({}),
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HeaderDesktopModule {}
